/* AHH 2026 version 2: the Shop panel and the potency picker with Add to cart on search and collection cards.
   Plain script (no build step). It only touches elements that carry a data-ahh-... attribute. */
(() => {
  'use strict';

  /* ------------------------------------------------------------------
     1. Shop panel (desktop drop-down, phone bottom sheet)
     ------------------------------------------------------------------ */
  const initShop = () => {
    const root = document.querySelector('[data-ahh-shop]');
    if (!root || root.dataset.ahhReady === 'true') return;
    root.dataset.ahhReady = 'true';

    const sheet = root.querySelector('.ahh-shop__sheet');
    const tabs = Array.from(root.querySelectorAll('[data-ahh-shop-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-ahh-shop-panel]'));
    const wide = window.matchMedia('(min-width: 1280px)');
    let lastTrigger = null;

    const setTab = (name, moveFocus) => {
      tabs.forEach((tab) => {
        const on = tab.dataset.ahhShopTab === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && moveFocus) tab.focus();
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.ahhShopPanel === name);
      });
    };

    const place = () => {
      if (wide.matches) {
        const header = document.querySelector('#header-component');
        const bottom = header ? Math.round(header.getBoundingClientRect().bottom) : 0;
        root.style.setProperty('--ahh-shop-top', Math.max(bottom, 0) + 'px');
      } else {
        root.style.removeProperty('--ahh-shop-top');
      }
    };

    const syncTriggers = (isOpen) => {
      document.querySelectorAll('[data-ahh-shop-open]').forEach((el) => {
        el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        el.classList.toggle('is-open', isOpen);
      });
    };

    const open = (trigger) => {
      lastTrigger = trigger || null;
      /* If the phone menu is open, close it first so the two never overlap */
      const drawer = document.querySelector('#header-component .menu-drawer-container[open]');
      if (drawer) {
        const closeButton = drawer.querySelector('.menu-drawer__close-button');
        if (closeButton) closeButton.click();
        else drawer.removeAttribute('open');
      }
      place();
      root.hidden = false;
      document.documentElement.classList.add('ahh-shop-open');
      syncTriggers(true);
      if (sheet) sheet.focus({ preventScroll: true });
    };

    const close = (restoreFocus) => {
      if (root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('ahh-shop-open');
      syncTriggers(false);
      if (restoreFocus && lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus({ preventScroll: true });
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setTab(tab.dataset.ahhShopTab, false));
      tab.addEventListener('keydown', (event) => {
        let next = -1;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        setTab(tabs[next].dataset.ahhShopTab, true);
      });
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const opener = target.closest('[data-ahh-shop-open]');
      if (opener) {
        event.preventDefault();
        if (root.hidden) open(opener);
        else close(true);
        return;
      }

      if (root.hidden) return;

      if (target.closest('[data-ahh-shop-close]')) {
        close(true);
        return;
      }
      if (target.closest('.ahh-shop__sheet a')) {
        /* The customer is going to another page: just let the link work */
        close(false);
        return;
      }
      if (!target.closest('.ahh-shop__sheet')) close(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        event.preventDefault();
        close(true);
      }
    });

    const onChange = () => {
      if (!root.hidden) place();
    };
    if (wide.addEventListener) wide.addEventListener('change', onChange);
    window.addEventListener('resize', onChange, { passive: true });
    window.addEventListener('scroll', onChange, { passive: true });
    window.addEventListener('pageshow', () => close(false));
  };

  /* ------------------------------------------------------------------
     2. Potency / size picker with Add to cart on product cards
     ------------------------------------------------------------------ */
  const money = (cents) => {
    const value = cents / 100;
    const whole = Math.abs(value - Math.round(value)) < 0.005;
    return (
      '₹' +
      value.toLocaleString('en-IN', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      })
    );
  };

  const load = (buy) => {
    if (buy._ahh) return buy._ahh;
    const node = buy.querySelector('[data-ahh-variants]');
    if (!node) return null;
    let data;
    try {
      data = JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
    if (!data || !data.variants || !data.variants.length) return null;

    const names = data.names || [];
    const selected = names.map(() => '');
    /* An option with only one value (for example a single pack size) is chosen for the customer */
    names.forEach((name, index) => {
      const values = new Set(data.variants.map((variant) => variant.o[index]));
      if (values.size === 1) selected[index] = data.variants[0].o[index];
    });

    buy._ahh = {
      data,
      names,
      selected,
      idInput: buy.querySelector('[data-ahh-id]'),
      priceNode: buy.querySelector('[data-ahh-price]'),
      addButton: buy.querySelector('[data-ahh-add]'),
      message: buy.querySelector('[data-ahh-msg]'),
      groups: Array.from(buy.querySelectorAll('[data-ahh-group]')),
      variant: null
    };
    return buy._ahh;
  };

  const setButton = (state, text, enabled) => {
    state.addButton.textContent = text;
    state.addButton.disabled = !enabled;
    state.addButton.classList.toggle('is-waiting', !enabled);
  };

  const refresh = (buy) => {
    const state = load(buy);
    if (!state || !state.addButton || !state.priceNode) return;
    const { data, names, selected } = state;

    state.groups.forEach((group) => {
      const index = Number(group.dataset.index);
      group.querySelectorAll('[data-ahh-pill]').forEach((pill) => {
        pill.setAttribute('aria-pressed', pill.dataset.value === selected[index] ? 'true' : 'false');
        /* Dim a choice that does not exist together with what is already chosen; tapping it still works */
        const exists = data.variants.some(
          (variant) =>
            variant.o[index] === pill.dataset.value &&
            selected.every((value, other) => other === index || !value || variant.o[other] === value)
        );
        pill.classList.toggle('is-off', !exists);
      });
    });

    const pool = data.variants.filter((variant) =>
      selected.every((value, index) => !value || variant.o[index] === value)
    );
    const complete = selected.every(Boolean);

    if (complete) {
      const variant = pool[0];
      if (!variant) {
        state.variant = null;
        state.priceNode.textContent = '';
        setButton(state, 'Not available', false);
        return;
      }
      state.variant = variant;
      if (state.idInput) state.idInput.value = variant.id;
      state.priceNode.textContent = money(variant.p);
      setButton(state, variant.a ? 'Add to cart' : 'Sold out', variant.a);
      return;
    }

    state.variant = null;
    const inStock = pool.filter((variant) => variant.a);
    const list = inStock.length ? inStock : pool;
    const lowest = Math.min.apply(
      null,
      list.map((variant) => variant.p)
    );
    const same = list.every((variant) => variant.p === list[0].p);
    state.priceNode.textContent = (same ? '' : 'From ') + money(lowest);

    const missing = selected.findIndex((value) => !value);
    const label = (names[missing] || 'option').toLowerCase();
    setButton(state, 'Choose a ' + label + ' first', false);
  };

  const initBuy = (scope) => {
    (scope || document).querySelectorAll('[data-ahh-buy]').forEach((buy) => {
      if (buy.dataset.ahhReady === 'true') return;
      buy.dataset.ahhReady = 'true';
      refresh(buy);
    });
  };

  const choose = (pill) => {
    const buy = pill.closest('[data-ahh-buy]');
    const group = pill.closest('[data-ahh-group]');
    if (!buy || !group) return;
    const state = load(buy);
    if (!state) return;

    const index = Number(group.dataset.index);
    state.selected[index] = pill.dataset.value;
    /* If the other choice no longer fits, clear it so the customer is never stuck */
    state.names.forEach((name, other) => {
      if (other === index || !state.selected[other]) return;
      const fits = state.data.variants.some((variant) =>
        state.selected.every((value, position) => !value || variant.o[position] === value)
      );
      if (!fits) state.selected[other] = '';
    });
    if (state.message) {
      state.message.textContent = '';
      state.message.classList.remove('is-error');
    }
    refresh(buy);
  };

  const sectionIds = () => {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((component) => {
      if (component instanceof HTMLElement && component.dataset.sectionId) ids.push(component.dataset.sectionId);
    });
    return ids;
  };

  /* Tell the theme the cart changed, so the cart count and the cart drawer update (same method as the combination builder) */
  const syncThemeCart = (variantId, addResponse) =>
    import('@shopify/events').then((cartEvents) => {
      const deferred = cartEvents.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new cartEvents.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        })
      );

      return fetch('/cart.js', { method: 'GET', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then((response) => {
          if (!response.ok) throw new Error('Could not refresh the cart.');
          return response.json();
        })
        .then((cart) => {
          deferred.resolve({
            cart: cartEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'ahh-card-buy',
              sourceId: 'ahh-card-buy',
              itemCount: 1,
              sections: addResponse && addResponse.sections,
              didError: false
            }
          });
          return cart;
        })
        .catch((error) => {
          deferred.reject(error);
          throw error;
        });
    });

  const addToCart = (buy) => {
    const state = load(buy);
    if (!state || !state.variant || !state.variant.a || state.busy) return;

    const variant = state.variant;
    state.busy = true;
    state.addButton.disabled = true;
    state.addButton.textContent = 'Adding...';
    if (state.message) {
      state.message.textContent = '';
      state.message.classList.remove('is-error');
    }
    let itemWasAdded = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variant.id, 10), quantity: 1 }],
        sections: sectionIds().join(','),
        sections_url: window.location.pathname
      })
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add to cart.');
          }
          return data;
        })
      )
      .then((addResponse) => {
        itemWasAdded = true;
        return syncThemeCart(variant.id, addResponse);
      })
      .then(() => {
        state.busy = false;
        refresh(buy);
        state.addButton.textContent = 'Added ✓';
        state.addButton.classList.add('is-added');
        if (state.message) state.message.textContent = 'Added to your cart.';
        window.setTimeout(() => {
          state.addButton.classList.remove('is-added');
          refresh(buy);
        }, 2600);
      })
      .catch((error) => {
        state.busy = false;
        if (itemWasAdded) {
          /* The item is in the cart; only the screen refresh failed. The cart page shows the truth. */
          window.location.assign('/cart');
          return;
        }
        refresh(buy);
        if (state.message) {
          state.message.textContent =
            error && error.message
              ? error.message
              : 'Something went wrong adding this to your cart. Please try again.';
          state.message.classList.add('is-error');
        }
      });
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const pill = target.closest('[data-ahh-pill]');
    if (pill) {
      event.preventDefault();
      event.stopPropagation();
      choose(pill);
      return;
    }

    const add = target.closest('[data-ahh-add]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      const buy = add.closest('[data-ahh-buy]');
      if (buy) addToCart(buy);
    }
  });

  /* ------------------------------------------------------------------
     Start-up, and again whenever the theme swaps the product grid (filters, sorting, next page)
     ------------------------------------------------------------------ */
  const start = () => {
    initShop();
    initBuy(document);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  let pending = 0;
  const watch = () => {
    const host = document.getElementById('MainContent');
    if (!host) return;
    new MutationObserver(() => {
      window.cancelAnimationFrame(pending);
      pending = window.requestAnimationFrame(() => initBuy(host));
    }).observe(host, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
